import { defineStore } from "pinia";

export const useAppointmentRatingPendingStore = defineStore(
  "appointmentRatingPending",
  {
    state: (): { pending: any } => ({ pending: null }),
    persist: true,
    actions: {
      save(pending: any) {
        this.pending = pending;
      },
      clear() {
        this.pending = null;
      },
    },
  },
);
